<template>
<div v-if="show" class="tipsContent" :class="extClass" id="tipsContent">
    <div class="tips" v-text="tips"></div>
</div>
</template>
<script>
export default {
    name: 'Tips',
    props: {
        extClass: {
            type: String,
            default: '',
        },
        tips: {
            type: String,
            default: '',
        },
        show: {
            type: Boolean,
            default: false,
        },
        delay: {
            type: Number,
            default: 1500,
        },
    },
};
</script>
<style scoped lang="scss">
.tipsContent {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: fixed;;
    top: 50%;
    left: 50%;
    transform: translate(-50%,50%);
    padding: 5px 10px;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 14px;
    z-index: 999;
    border-radius: 5px;
    white-space: nowrap;
}
</style>
